import api from './api';

/** Zendesk ticket statuses, lowercase as the API returns them. */
/**
 * Zendesk's own statuses, plus the three derived from a linked DevOps work item
 * (see backend app/services/devops_ticket_status.py).
 */
export type TicketStatus =
  | 'new' | 'open' | 'pending' | 'hold' | 'solved' | 'closed'
  | 'in_progress' | 'blocked' | 'resolved';

export interface MyTicket {
  id: number;
  subject: string | null;
  status: TicketStatus;
  /** Set when the ticket has been triaged into DevOps. */
  devopsWorkItemId?: number | null;
  created_at: string | null;
  updated_at: string | null;
  tags: string[];
  submission_type: 'bug' | 'feature' | 'helpdesk';
  /** Help Center request page for this ticket. */
  url: string;
}

export type UnseenClosedTicket = MyTicket;

const myTicketsService = {
  async listMyTickets(): Promise<MyTicket[]> {
    const response = await api.get('/my-tickets');
    return response.data.data as MyTicket[];
  },

  async getUnseenClosed(): Promise<UnseenClosedTicket[]> {
    const response = await api.get('/my-tickets/unseen-closed');
    return response.data.data as UnseenClosedTicket[];
  },

  async acknowledgeTicket(ticketId: number): Promise<void> {
    await api.post(`/my-tickets/${ticketId}/acknowledge`);
  },
};

export default myTicketsService;
